<template>
	<div>
		<div v-if="isUserAllowedInLevel1 || isAuthenticatedUserInGroupAdmin">
			<BaseHeader :title="getTitle">
				<div class="flex items-center">
					<BaseButton class="btn-blue" @click="$router.push({ name: 'NewChildCompany' })" v-if="!this.$route.params.id" disabled="true" hidden>{{
						$t('add_employee')
					}}</BaseButton>
				</div>
			</BaseHeader>
			<div class="main">
				<div v-if="companies">
					<div class="flex flex-col">
						<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
							<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
								<div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
									<table class="min-w-full divide-y divide-gray-200">
										<thead>
											<tr>
												<th
													v-for="header in getHeader"
													:key="header.name"
													:class="header.class"
													class="py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
												>
													{{ header.name }}
												</th>
											</tr>
										</thead>
										<tbody class="bg-white divide-y divide-gray-200">
											<ChildCompanyRow v-for="childCompany in companies" :key="childCompany.id" :company="childCompany" />
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<LoadingSpinner />
				</div>
				<div v-if="$route.params.backlink" class="mt-8 mb-8 flex justify-between">
					<BaseButton @click="$router.push($route.params.backlink)" class="mr-4">{{ $t('general.back') }}</BaseButton>
				</div>
			</div>
		</div>
		<div v-else>
			<Forbidden />
		</div>
		<router-view />
	</div>
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import ChildCompanyRow from '@/components/rows/ChildCompanyRow';
import { CompanyApiFactory, UserApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseButton from '@/components/forms/buttons/BaseButton';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden';
import RouteWatcher from '@/mixins/RouteWatcher';

export default {
	name: 'CompanyChildrenOverview',
	components: { Forbidden, LoadingSpinner, BaseSelect, BaseButton, ChildCompanyRow, BaseHeader },
	mixins: [Authentication, RouteWatcher],
	data() {
		return {
			employees: '',
			companies: [],
			company: null,
			companyID: '',
			filterOptions: [
				{
					display: this.$t('active'),
					value: 'enabled',
				},
				{
					display: this.$t('disabled'),
					value: 'disabled',
				},
				{
					display: this.$t('all'),
					value: 'all',
				},
			],
			filter: {
				display: this.$t('active'),
				value: 'enabled',
			},
		};
	},
	methods: {
		onRouteChange() {
			this.company = null;
			this.companies = null;
			this.loadChildCompanies();
		},
		loadChildCompanies() {
			if (this.$route.params.id) {
				const companyApiFactory = CompanyApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios);
				companyApiFactory.childCompaniesIdGet(this.$route.params.id).then(response => {
					this.companies = response.data;
				});
				companyApiFactory.companyIdGet(this.$route.params.id).then(response => {
					this.company = response.data;
				});
			}

			const companyApiFactory = CompanyApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios);
			companyApiFactory.childCompaniesGet().then(response => {
				this.companies = response.data;
			});
		},
	},
	computed: {
		getTitle() {
			return this.$t('child_company');
			//return this.$route.params.id && this.company?.name ? this.$t('employee_of') + ' ' + this.company.name : this.$t('employee');
		},
		getEnabledEmployees() {
			return this.employees.filter(employee => employee.is_enabled);
		},
		getDisabledEmployees() {
			return this.employees.filter(employee => !employee.is_enabled);
		},
		getEmployees() {
			let employees;
			switch (this.filter.value) {
				case 'enabled':
					employees = this.getEnabledEmployees;
					break;
				case 'disabled':
					employees = this.getDisabledEmployees;
					break;
				default:
					employees = this.employees;
					break;
			}

			return employees;
		},
		getHeader() {
			const header = [];
			header.push({ name: 'Firma', class: 'px-6' });
			header.push({ name: 'Leitung', class: 'px-6' });
			header.push({ name: 'Anschrift', class: 'px-6' });

			if (this.filter === this.filterOptions[2]) {
				header.push({ name: 'Aktiv', class: 'px-6' });
			}

			return header;
		},
	},
};
</script>
